(ns common.schema.entities.workspace.kyc.templates.flow-through-jurisdiction
  (:require
   [common.schema.entities.workspace.kyc.questions.questions-registry :as questions-registry]))

(def schema
  {:kyc-template/template-name
   "Flow-through Ownership Jurisdiction"
   :kyc-template/kyc-form-preface
   {:translations {:en "Flow-through ownership jurisdiction information"}}

   :kyc-flow-through-jurisdiction.group/basic-information
   {:ord          1.0
    :translations {:en "Jurisdiction Information"}
    :questions    (questions-registry/resolve-questions
                   [[:kyc-flow-through-jurisdiction/jurisdiction
                     {:mandatory-field? true
                      :info {:en "Home tax jurisdiction of the investors in the Investor/IBO"}
                      :info-position :below-input}]
                    [:kyc-flow-through-jurisdiction/ownership-percent
                     {:mandatory-field? true
                      :info {:en "% of investors in the Investor/IBO in this jurisdiction. If known, split this % between taxable and tax exempt investors below"}
                      :info-position :below-input}]
                    [:kyc-flow-through-jurisdiction/taxable-percent]
                    [:kyc-flow-through-jurisdiction/tax-exempt-percent]
                    [:kyc-flow-through-jurisdiction/is-transparent]
                    [:kyc-flow-through-jurisdiction/is-taxed-as-income-arises]
                    [:kyc-flow-through-jurisdiction/notes
                     {:info {:en "Additional notes regarding this jurisdiction. For example, if an answer to some of the fields above is unclear as a matter of law, please note it here."}
                      :info-position :below-input}]])}})
